// Manager queue: pending timecard entries with inline approve/reject/edit.

import { useEffect, useState } from 'react';
import { api } from '../../api';

function fmt(s) { if (!s) return '—'; return new Date(s + (s.endsWith('Z') ? '' : 'Z')).toLocaleString(); }
function hours(sec) { if (sec == null) return '—'; return (sec / 3600).toFixed(2) + 'h'; }

export default function TimecardReviewPage() {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [edits, setEdits] = useState({});
  const [notes, setNotes] = useState({});

  function load() {
    api.payrollReviewQueue().then(setRows).catch(e => setErr(e.message));
  }
  useEffect(() => { load(); }, []);

  async function approve(id) {
    setBusy(true);
    try {
      if (edits[id] != null) {
        await api.editTimecard(id, { adjusted_total_seconds: Math.round(parseFloat(edits[id]) * 3600), manager_notes: notes[id] || null });
      }
      await api.approveTimecard(id, notes[id] || null);
      load();
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  }
  async function reject(id) {
    setBusy(true);
    try {
      await api.rejectTimecard(id, notes[id] || 'Rejected');
      load();
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  }

  return (
    <div className="page">
      <div className="page-header"><h2>Timecard Review</h2></div>
      {err && <div className="error-banner">{err}</div>}
      <div className="muted" style={{ marginBottom: 12 }}>{rows.length} entries pending review.</div>
      <table className="data-table">
        <thead>
          <tr>
            <th>Dispatcher</th>
            <th>Station</th>
            <th>Clock In</th>
            <th>Clock Out</th>
            <th>Hours</th>
            <th>Adjust</th>
            <th>Manager Notes</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.id}>
              <td>{r.full_name}</td>
              <td>{r.station_name || '—'}</td>
              <td>{fmt(r.clock_in_at)}</td>
              <td>{fmt(r.clock_out_at)}</td>
              <td>{hours(r.total_seconds)}</td>
              <td>
                <input
                  type="number" step="0.25" min="0" max="24"
                  placeholder={(r.total_seconds / 3600).toFixed(2)}
                  value={edits[r.id] ?? ''}
                  onChange={e => setEdits(x => ({ ...x, [r.id]: e.target.value }))}
                  style={{ width: 80 }}
                />
              </td>
              <td>
                <input
                  type="text"
                  value={notes[r.id] || ''}
                  onChange={e => setNotes(x => ({ ...x, [r.id]: e.target.value }))}
                />
              </td>
              <td>
                <button className="btn-primary" disabled={busy} onClick={() => approve(r.id)}>Approve</button>
                <button className="btn-secondary" disabled={busy} onClick={() => reject(r.id)}>Reject</button>
              </td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan="8" className="empty">No timecards pending review.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
